export const FileTypeEnum = {
  // excel
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLS: 'application/vnd.ms-excel',
  X_XLS: 'application/x-xls',

  // txt
  TXT: 'text/plain',

  // 日期范围报告的CSV格式是这样的
  CSV: 'application/vnd.ms-excel',
  X_CSV: 'text/csv',

  IMAGE: 'image/*',
  JPG: 'image/jpg',
  JPEG: 'image/jpeg',
  PNG: 'image/png'
};
